import React, { useEffect } from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, useLocation } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import SolarCalculator from "./pages/calculadora";
import ProjectPortfolio from "./pages/proyectos";
import AboutSolarValley from "./pages/nosotros";
import ServicesOverview from "./pages/servicios";
import WarrantyInformation from "./pages/garantias";
import Home from "./pages/home";
import { logPageView } from "lib/analytics";

// Component to track page views on route change
const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    logPageView();
  }, [location]);

  return null;
};

const Routes = () => {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ErrorBoundary>
        <PageTracker />
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your route here */}
          <Route path="/" element={<Home />} />
          <Route path="/calculadora" element={<SolarCalculator />} />
          <Route path="/proyectos" element={<ProjectPortfolio />} />
          <Route path="/nosotros" element={<AboutSolarValley />} />
          <Route path="/servicios" element={<ServicesOverview />} />
          <Route
            path="/garantias"
            element={<WarrantyInformation />}
          />
          <Route path="/home" element={<Home />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
